// 通知偏好（NOTIF-02）：notify 的設定（app-api 轉給 notify 的 handler；每個 plane 一份）。VMS 只是編輯介面，偏好存在 notify。
import { kinioFetch, planeBase } from '@kinio/web-sdk';

export interface NotifyPref {
  enabled?: boolean;
  push?: boolean;
  email?: boolean;
  reset?: boolean;
}

export interface NotifySettings {
  quiet_hours?: { start: string; end: string; tz?: string } | null;
  hide_details?: boolean;
  thumbnails?: boolean;
  email_alerts?: boolean;
  /** AI-02：偵測通知只送雲端 AI 確認的（這台正在被分析時才生效，60 秒沒判定照常送） */
  ai_confirmed_only?: boolean;
  categories?: Record<string, NotifyPref>;
  things?: Record<string, Record<string, NotifyPref>>;
  forced_list_version: number;
  forced: string[];
  configurable: string[];
}

/** 回應缺欄位（沒開 notify 的 plane）不能讓整頁掛掉：陣列 / 物件欄位補空的。 */
function norm(s: NotifySettings | null | undefined): NotifySettings {
  const x = (s ?? {}) as NotifySettings;
  return { ...x, forced: x.forced ?? [], configurable: x.configurable ?? [], categories: x.categories ?? {} };
}

export const notifySettingsApi = {
  mine: (api: string) => kinioFetch<NotifySettings>(`${planeBase(api)}/v1/me/notification-settings`).then(norm),
  putMine: (api: string, body: Partial<NotifySettings>) =>
    kinioFetch<NotifySettings>(`${planeBase(api)}/v1/me/notification-settings`, { method: 'PUT', body }).then(norm),
  home: (api: string, homeId: string) =>
    kinioFetch<NotifySettings>(`${planeBase(api)}/v1/homes/${encodeURIComponent(homeId)}/notification-settings`).then(norm),
  putHome: (api: string, homeId: string, body: Partial<NotifySettings>) =>
    kinioFetch<NotifySettings>(`${planeBase(api)}/v1/homes/${encodeURIComponent(homeId)}/notification-settings`, { method: 'PUT', body }).then(norm),
};

/** 類別的有效值：家戶層有設就用它，沒有就預設開（notify §9.1：沒列 = 預設）。 */
export function effective(p: NotifyPref | undefined): { enabled: boolean; push: boolean; email: boolean } {
  return { enabled: p?.enabled ?? true, push: p?.push ?? true, email: p?.email ?? false };
}

/** HH:MM */
export function validHHMM(s: string): boolean {
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(s);
}
